import _ from 'lodash';
import React from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';

import useSpecialMenuCards from 'src/dispensary/hooks/use-special-menu-cards';
import usePaths from 'src/hooks/use-paths';
import { OfferCarousel as OfferCarouselV2 } from 'src/components/carousel-v2/types/offer-carousel';

export function SpecialOffersCarousel(props) {
  const flags = useFlags();
  // TODO: Change this LD flag to a setting on the Carousel in the admin.
  const showAllSpecialsInOffersCarousel = flags['growth.ecomm.show-all-specials-in-offers-carousel'] ?? false;

  const { loading, specials } = useSpecialMenuCards();
  const offers = showAllSpecialsInOffersCarousel ? specials : _.filter(specials, [`specialType`, `bogo`]);

  const { href } = usePaths({ specials: true });
  // Optional caller-supplied heading, used by the CMS Product Carousel block. See
  // staff-picks-carousel.jsx for why `section.label` is deliberately not used.
  const title = props?.title ?? (showAllSpecialsInOffersCarousel ? 'Specials' : `Offers`);

  if (!offers?.length && !loading) {
    return null;
  }

  return (
    <OfferCarouselV2
      offers={offers}
      href={href}
      title={title}
      hideTitle={props?.showTitle === false}
      hideLink={props?.showLink === false}
    />
  );
}
